exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntextarea {\n  margin-top: 0px !important;\n  padding-bottom: 24px !important;\n}\n.phonepreview {\n  background-position: center top;\n  margin-top: 10px;\n}\n", ""]);

